import { useState } from "react";

// Copy-to-clipboard button with a plain-textarea fallback for sandboxed
// iframes where navigator.clipboard is unavailable. Shared by the Website
// Tests and Athlete Sites galleries.
export default function CopyButton({ url, testid }) {
  const [copied, setCopied] = useState(false);
  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch {
      // Fallback for sandboxed iframes
      const ta = document.createElement("textarea");
      ta.value = url;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand("copy"); setCopied(true); setTimeout(() => setCopied(false), 1800); }
      finally { document.body.removeChild(ta); }
    }
  };
  return (
    <button type="button" className="btn btn-sm" onClick={onCopy} data-testid={testid}>
      {copied ? "Link copied!" : "Copy share link"}
    </button>
  );
}
